<template>
  <div class="modal share animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
      </header>
      <section class="modal-card-body">
        <img src="/images/logo.png">
        <h3><span>XOXO</span>{{ $t('share_modal.spread_the_love') }}</h3>
        <p>{{ $t('share_modal.message') }}</p>
        <div class="social-icons">
          <a class="social_share_link twitter" href="https://twitter.com/intent/tweet?text=Have%20you%20guys%20checked%20out%20%40WorkpapersApp%20yet%3F%20I%20love%20it!%20%23proposals%20https%3A%2F%2workapers.io"><i class="icon icon-twitter"></i></a>
          <a class="social_share_link facebook" href="https://www.facebook.com/dialog/feed?app_id=184683071273&link=https%3A%2F%2Fworkpapers.io&picture=&name=Workpapers%20Proposal%20Software&caption=%20&description=Simple%20%26%20elegant%20proposal%20software%20for%20freelancers%20and%20small%20to%20medium%20sized%20agencies.&redirect_uri=https%3A%2F%2Fwww.facebook.com%2F"><i class="icon icon-facebook"></i></a>
        </div>
      </section>
      <footer class="modal-card-foot">
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Events: window.Events
    }
  },
  methods: {
    closeModal() {
      this.Events.$emit('modalClose', 'shareModal');
    }
  }
}
</script>

<style lang="scss" scoped>

  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }
  .modal-background {
    background: hsla(0,0%,100%,.3);
  }
  img {
    width: 200px;
    display: block;
    margin: 0 auto 40px;
  }
  h3 {
    font-size: 28px;
    text-transform: uppercase;
    font-weight: 900;
    margin: 0 0 20px;
    letter-spacing: 1px;
    text-align: center;
    span {
      display: block;
      font-size: 13px;
      font-weight: 500;
    }
  }
  p {
    text-align: center;
  }
  .social-icons {
    text-align: center;
    margin: 30px 0 64px;
    a {
      margin: 0 40px 0 0;
      width: 76px;
      display: inline-block;
      i {
        font-size: 60px;
      }
      &.twitter {
        color: #55acee;
        &:hover {
          color: darken(#55acee, 10%);
        }
      }
      &.facebook {
        color: #3b5998;
        &:hover {
          color: darken(#3b5998, 10%);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// share-modal.vue?0fe61bdf